import type { NamespaceSchema } from './types';

export const enquirySettings: NamespaceSchema = {
  namespace: 'enquiry-settings',
  label: 'Enquiry',
  description: 'Per-car enquiry forms ("ask the host"). Routes to inquiries collection.',
  sections: [
    {
      label: 'Behaviour',
      fields: [
        { kind: 'boolean', key: 'enabled', label: 'Enquiry button on car page', default: true },
        { kind: 'boolean', key: 'requires_auth', label: 'Require login to send', default: true },
        { kind: 'boolean', key: 'enable_recaptcha', label: 'reCAPTCHA on enquiry form', default: false },
        { kind: 'select', key: 'mode', label: 'Per-service mode', default: 'always', options: [
          { value: 'always', label: 'Always shown' },
          { value: 'when_unavailable', label: 'Only when dates unavailable' },
          { value: 'never', label: 'Never shown' },
        ] },
      ],
    },
    {
      label: 'Notifications',
      fields: [
        { kind: 'boolean', key: 'mail_to_admin', label: 'Email admin on new enquiry', default: true },
        { kind: 'boolean', key: 'mail_to_vendor', label: 'Email vendor on new enquiry', default: true },
        { kind: 'textarea', key: 'mail_to_admin_content', label: 'Admin email body', rows: 4, description: 'Supports {customer.name}, {car.title}, {message}.' },
        { kind: 'textarea', key: 'mail_to_vendor_content', label: 'Vendor email body', rows: 4 },
      ],
    },
  ],
};
